import { AnalyticsTypes } from '../../../utils/google-analytics';
import {
    ACTION_TYPES,
    TRACKING_CONSTANTS,
} from './constants';

export const trackPpsChange = ({ query, gaCategory }) => ({
    type: ACTION_TYPES.trackPpsChange,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Change Doctor/Practice Name',
            label: query,
            category: gaCategory,
            data: {
                Component: TRACKING_CONSTANTS.patientPoweredSearch,
                Element: TRACKING_CONSTANTS.patientPoweredSearchSearchQuery,
                EventDetails: { Query: query },
                Initiator: TRACKING_CONSTANTS.user,
                InteractionType: TRACKING_CONSTANTS.type,
                Section: TRACKING_CONSTANTS.searchBar,
            },
        },
    },
});

export const trackPpsFocus = gaCategory => ({
    type: ACTION_TYPES.trackPpsFocus,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click PatientPoweredSearch TextBox',
            category: gaCategory,
            data: {
                Component: TRACKING_CONSTANTS.patientPoweredSearch,
                Element: TRACKING_CONSTANTS.patientPoweredSearchSearchField,
                Initiator: TRACKING_CONSTANTS.user,
                InteractionType: TRACKING_CONSTANTS.click,
                Section: TRACKING_CONSTANTS.searchBar,
            },
        },
    },
});

export const trackPpsSelect = ({ selection, selectionType, gaCategory }) => {
    const eventDetails = {
        Selection: selection,
        SelectionType: selectionType,
    };
    return {
        type: ACTION_TYPES.trackPpsSelect,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Select PatientPoweredSearch Option',
                label: eventDetails,
                category: gaCategory,
                data: {
                    Component: TRACKING_CONSTANTS.patientPoweredSearch,
                    Element: TRACKING_CONSTANTS.patientPoweredSearchSearchAutocompleteTerm,
                    EventDetails: eventDetails,
                    Initiator: TRACKING_CONSTANTS.user,
                    InteractionType: TRACKING_CONSTANTS.click,
                    Section: TRACKING_CONSTANTS.searchBar,
                },
            },
        },
    };
};
